(function() {

  var cards = [
    {
      id:  "link-Tech Gear",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Tech_Gear_-_Waders_16x9_8e74a478-5533-48c9-8f7c-bca79fb8c4ef.jpg?v=1775694605",
      cta: "Shop Waders",
      url: "/collections/duck-hunting-waders"
    },
    {
      id:  "link-Everyday",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Everyday_-_Bottoms_16x9_bf774c2b-1676-4d52-bf32-20b639f89dd9.jpg?v=1775694604",
      cta: "Shop Pants",
      url: "/collections/lifestyle-bottoms"
    },
    {
      id:  "link-Bags",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Bags_-_Dry_Line_Bags_16x9_b5da7f26-a5db-40a5-b622-23721f162ab1.jpg?v=1775694604",
      cta: "Shop Dry Line Bags",
      url: "/collections/dry-line-bags"
    },
    {
      id:  "link-Decoys",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Decoys_-_Mallard_Decoys_16x9_1f73f298-5ed7-4dcc-91ba-feec4af2064e.jpg?v=1775694604",
      cta: "Shop Duck Decoys",
      url: "/collections/duck-decoys"
    },
    {
      id:  "link-Blinds",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Blinds_-_Layout_Field_Blinds_16x9_413752a6-7cf8-4d4c-8343-a0f1b45f1672.jpg?v=1775694604",
      cta: "Shop Blinds",
      url: "/collections/layout-field-blinds"
    },
    {
      id:  "link-Accessories",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Accessories_-_Field_Tech_16x9_a3afa3b2-84de-4896-bc81-d344cb3b81a4.jpg?v=1775694604",
      cta: "Shop Field Tech",
      url: "/collections/field-tech"
    },
    {
      id:  "link-Outlet",
      img: "https://cdn.shopify.com/s/files/1/0598/0871/0708/files/Outlet_16x9_016d1f25-b116-4738-98b9-70d1ab16fe50.jpg?v=1775694605",
      cta: "Shop Outlet",
      url: "/collections/outlet"
    }
  ];

  var css = `
    .nav-card {
      margin: 8px 16px 0;
      border-radius: 6px;
      overflow: hidden;
    }
    .nav-card a {
      display: block;
      text-decoration: none;
    }
    .nav-card img {
      width: 100%;
      display: block;
      object-fit: cover;
      object-position: center top;
      height: 120px;
    }
    @media (min-height: 700px) {
      .nav-card img { height: 200px; }
    }
    @media (min-height: 800px) {
      .nav-card img { height: 280px; }
    }
    @media (min-height: 900px) {
      .nav-card img { height: 360px; }
    }
    .nav-card span {
      display: block;
      text-align: center;
      background: #007BB8;
      color: #ffffff;
      font-family: Rift-Bold, sans-serif;
      font-size: 14px;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      padding: 13px 16px;
    }
    .nav-card a:hover span { background: #005681; }
  `;

  var styleEl = document.createElement("style");
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function inject() {
    cards.forEach(function(card) {
      var submenu = document.getElementById(card.id);
      if (!submenu) return;
      if (submenu.querySelector(".nav-card")) return;

      var inner = submenu.querySelector(".menu-drawer__submenu-inner");
      if (!inner) return;

      var el = document.createElement("div");
      el.className = "nav-card";
      el.innerHTML =
        '<a href="' + card.url + '">' +
        '<img src="' + card.img + '" alt="' + card.cta + '" loading="lazy">' +
        '<span>' + card.cta + '</span>' +
        '</a>';

      inner.appendChild(el);

      // Only set height on taller screens
      if (window.innerHeight >= 700) {
        var h = window.innerHeight;
        var imgHeight = h < 800 ? 220 : h < 900 ? 300 : 380;
        el.querySelector("img").style.height = imgHeight + "px";
      }
    });
  }

  var observer = new MutationObserver(inject);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["open"]
  });

  inject();

})();